import {
  IBookingMenuOptionExtras,
  IPouchRowItem,
  IPouchRows,
  IPouchServicePaymentOption,
  IPouchUpdateResponse,
  IServicePaymentOption,
} from 'shared-types/index';
import PouchLoadService from 'external-services/pouch-load-service/index';
import { DocumentTypes } from 'booking-creator/components/BookingUpsellOptionsPanel/types';
import { cloneDeep } from 'lodash-es';

const NS = 'BookingOptionsManagerService';
class BookingOptionsManagerService {
  private trackEvent?: (eventName: any, values?: any) => void;

  setup(trackEvent?: (eventName: any, values?: any) => void) {
    this.trackEvent = trackEvent;
  }

  public getAll(): Promise<IPouchServicePaymentOption[]> {
    return new Promise((resolve) => {
      Promise.resolve(
        PouchLoadService.getDbLocal()
          .allDocs({
            include_docs: true,
            attachments: false,
            startkey: DocumentTypes.MenuOption + '_',
            endkey: DocumentTypes.MenuOption + '_\uffff',
          })
          .then((result: unknown) => {
            let items: IPouchServicePaymentOption[] = (
              result as IPouchRows<IPouchServicePaymentOption>
            ).rows.map((item: IPouchRowItem<IPouchServicePaymentOption>) => {
              return item.doc;
            });
            items = items.sort((a: IPouchServicePaymentOption, b: IPouchServicePaymentOption) => {
              return a.name > b.name ? 1 : -1;
            });

            resolve(items);
          })
      );
    });
  }

  public getById(id: string): Promise<IServicePaymentOption> {
    const option: Promise<IServicePaymentOption> = PouchLoadService.getDbLocal().get(id);

    return option;
  }

  public save(item: IServicePaymentOption): Promise<PouchDB.Core.Response> {
    this.prepareForSave(item);

    // Save/Update the document
    return Promise.resolve(PouchLoadService.getDbLocal().put(item));
  }

  public bulkSave(items: IServicePaymentOption[]): Promise<IPouchUpdateResponse[]> {
    items.forEach((item: IServicePaymentOption) => {
      this.prepareForSave(item);
    });

    // Save/Update the documents
    return Promise.resolve(
      PouchLoadService.getDbLocal().bulkDocs(items) as unknown as IPouchUpdateResponse[]
    );
  }

  public remove(item: Partial<IPouchServicePaymentOption>): Promise<PouchDB.Core.Response> {
    this.trackEvent &&
      this.trackEvent('Delete Option', {
        id: item._id,
        rev: item._rev,
      });
    return Promise.resolve(
      PouchLoadService.getDbLocal().remove(item as PouchDB.Core.RemoveDocument)
    );
  }

  private prepareForSave(item: Partial<IPouchServicePaymentOption>) {
    // Guard values
    item.type = DocumentTypes.MenuOption;

    // Create or Update operation, guard to _id
    if (!item._id) {
      item._id = PouchLoadService.getNewId([DocumentTypes.MenuOption]);
      this.trackEvent &&
        this.trackEvent('New Option', {
          id: item._id,
        });
    } else {
      this.trackEvent &&
        this.trackEvent('Edit Option', {
          id: item._id,
        });
    }
  }

  handleExtrasOnChange(
    quantity: number,
    extras: IBookingMenuOptionExtras
  ): IBookingMenuOptionExtras {
    if (extras) {
      const opts = cloneDeep(extras.explicitChildMenuOptions);
      if (extras.isSameForAll) {
        if (opts && opts.length) {
          opts[0].forEach((o) => (o.quantity = quantity));
        }
      } else {
        if (quantity < opts.length) {
          // if quantity decreased, then we remove overspill on explicitChildMenuOptions
          opts.length = quantity;
        } else if (quantity > opts.length) {
          // if quantity increases, then needs empty slots added
          for (let i = opts.length; i < quantity; i++) {
            opts.push([]);
          }
        }
      }
      extras = { ...extras, explicitChildMenuOptions: opts };
    }
    return extras;
  }
}

const instance = new BookingOptionsManagerService();
export default instance as BookingOptionsManagerService;
